<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h1>南意秋棠</h1>
        <h2>后台管理系统</h2>
      </div>
      <el-form
        ref="loginForm"
        :model="form"
        :rules="rules"
        class="login-form"
        @keyup.enter="handleLogin"
      >
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="form.username"
            prefix-icon="el-icon-user"
            placeholder="请输入用户名"
            clearable
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.password"
            prefix-icon="el-icon-lock"
            type="password"
            placeholder="请输入密码"
            show-password
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            class="login-button"
            @click="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'Login',
  setup() {
    const store = useStore()
    const router = useRouter()
    const loginForm = ref(null)
    const loading = ref(false)

    const form = reactive({
      username: '',
      password: ''
    })

    const rules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' },
        { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
      ]
    }

    const handleLogin = async () => {
      if (!loginForm.value) return
      
      try {
        const valid = await loginForm.value.validate()
        if (valid) {
          loading.value = true
          try {
            await store.dispatch('login', {
              username: form.username.trim(),
              password: form.password
            })
            router.push('/')
            ElMessage.success('登录成功')
          } catch (error) {
            console.error('Login error:', error)
            ElMessage.error(error.response?.data?.message || '登录失败，请检查用户名和密码')
          } finally {
            loading.value = false
          }
        }
      } catch (validationError) {
        console.error('Validation error:', validationError)
      }
    }

    return {
      loginForm,
      form,
      rules,
      loading,
      handleLogin
    }
  }
})
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
}

.login-box {
  width: 400px;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-header h1 {
  margin: 0;
  color: #2c3e50;
  font-size: 28px;
  margin-bottom: 8px;
}

.login-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 28px;
  margin-bottom: 30px;
}

.login-form {
  margin-top: 30px;
}

:deep(.el-form-item__label) {
  color: #606266;
  font-weight: 500;
  width: 80px !important;
}

.login-button {
  width: 100%;
  padding: 12px 0;
}

:deep(.el-input__inner) {
  padding-left: 40px !important;
}

:deep(.el-input__prefix) {
  left: 10px;
}
</style>